import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'solesCurrency'
})
export class SolesCurrencyPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null || value === '') return '';
    const num = Number(value);
    return `S/${num.toFixed(2)}`;
  }

}
